export class BaseEntity {
    constructor(){}

    ID: number = null;
    Checked: boolean;
    Selected: boolean;
    Editable: boolean;
    Deletable: boolean;
    Useridlk: number = null;
    // Datetimelk: Date = null;
    // Datetimelk: Date;
    IsDefault: boolean;
    // is_active: boolean = true;

    Deserialize(input: any){
        // this.Editable = input.yt ? !input.yt : true;
        // this.Deletable = input.yt ? !input.yt : true;
        // this.Editable = input.useridlk == null;
        // this.Deletable = input.useridlk == null;
        this.Editable = (input.yt || input.yt == false) && input.useridlk == null;
        this.Deletable = (input.yt || input.yt == false) && input.useridlk == null;
        this.Useridlk = input.useridlk;
        // this.Datetimelk = input.datetimelk;
        this.IsDefault = input.IsDefault ? input.IsDefault : false;
        // this.is_active = input.is_active;
        return this;
    }
    Serialize(input: this){
        return {};
    }
    GetInstance(modelClass: new() => this){
        return new modelClass();
    }
}
